import Navigation from './components/home/navigation/Navigation';
import Hero from './components/home/hero/Hero';
import About from './components/about/About';
import Projects from './components/projects/Projects';
import Footer from './components/footer/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navigation></Navigation>
      <Hero></Hero>
      <About></About>
      <Projects></Projects>
      <Footer></Footer>
    </div>
  );
};

export default App;
